import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of North Dakota",
  shortName: "BCBSND",
  slug: "bcbsnd-insurance",
  seoTitle:
    "Blue Cross Blue Shield of North Dakota (BCBSND) TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of North Dakota (BCBSND) policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBSND TMS coverage, Blue Cross Blue Shield North Dakota SPRAVATO authorization, BCBSND mental health benefits Coral Springs FL, BCBSND depression treatment Florida",
};

export const BcbsndInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsndInsurance;
